<template>
  <v-container grid-list-md>
    <v-row id="profile-layout" class="strategio-titles-windows">
      <v-col cols="20" align-self="center">
        <v-icon 
          :color="'black'" style="font-size:52px;padding-bottom: 30px; padding-right: 10px;">
          ico-icontune
        </v-icon>
        <span 
          style="font-size:45px;font-weight:bold;color:black;-webkit-text-stroke: 2px black;">
          Administrar usuarios
        </span>
      </v-col>
    </v-row>

    <v-row class="ma-5 px-5">
      <v-col cols="40">
        <v-card class="strategio-card-container">
          
          <v-card-text style="background-color:#23A2D9">
            <v-form id="usersfilter-textfield" @submit.prevent="search()">
              <v-text-field
                single-line
                outlined
                id="txtBuscar"
                name="txtBuscar"
                label="Buscar por nombre, cargo o correo"
                prepend-inner-icon="search"
                autocomplete="off"
                rounded
                hide-details="auto"
              >
                <template v-slot:append>
                <v-fade-transition leave-absolute>
                  <v-btn color="white" id="search-button" text icon @click="search()"
                    style="background-color:#23A2D9;width:41px;height: 41px; margin-top: -9px;" 
                  >
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                  </v-fade-transition>
                </template>
              </v-text-field>
            </v-form>
          </v-card-text>

          <v-card-text class="pa-0">  
            <v-data-table
              item-key="name"
              :headers="headers"
              :items="users"
              :loading="isLoading"
              sort-by="users"
              loading-text="Loading... Please wait"
              hide-default-header
            >
              <template v-slot:header="{ props: { headers } }">
                <thead style="background-color: #FDFDFD">
                  <tr style="height:80px">
                    <th style="text-align: center; font-size: 16px; color: black; font-family: 'Open Sans';" 
                      v-for="h in headers" :key="h.class" >
                      <span>{{h.text}}</span>
                    </th>
                  </tr>
                 </thead>
              </template>

              <template
                v-if="!isLoading"
                v-slot:body="{ items }"
              >
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="JSON.stringify(item)"
                  >
                    <td style="text-align: center;" :style="isEnabled(item.isEnabled)">
                      <v-chip
                        :color="getColor(item.userType)"
                        dark
                      >{{ item.userType }}</v-chip>
                    </td>
                    <td :style="isEnabled(item.isEnabled)">
                      <div>
                      {{ item.name }}
                      </div>
                    </td>
                    <td :style="isEnabled(item.isEnabled)">
                      <div>
                      {{ item.description }}
                      </div>
                    </td>
                    <td :style="isEnabled(item.isEnabled)">
                      <div>
                      {{ item.mail }}
                      </div>
                    </td>
                    <td style="text-align: center;">
                      <v-icon
                        small
                        class="mr-2"
                        @click="adminUser(item.userID)"
                      >
                        ico-icon-edit</v-icon>
                      <v-icon
                        small
                        class="mr-2"
                        @click="disableUser(item)"
                      >
                        ico-icon-disabled</v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
              
              <!-- <template v-slot:[`item.userType`]="{ item }">
                <v-chip
                  :color="getColor(item.userType)"
                  dark
                >{{ item.userType }}</v-chip>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="adminUser(item.userID)"
                >
                  ico-icon-edit</v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click="disableUser(item)"
                >
                  ico-icon-disabled</v-icon>
              </template> -->
              
              <!-- <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize()"
                >
                  Reset
                </v-btn>
              </template> -->
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import adminStorage from '../../storage/adminStorage'
import UsersListItem from '../users/users-list-item.vue'
import filter from 'lodash/filter'
import eventBus from '../../utils/eventBus'

let usersData = []

export default {
  name: 'users-list',
  data () {
    return {
      headers: [
        { text: 'Tipo de Usuario', value: 'userType', align: 'center', sortable: false },
        { text: 'Nombre del usuario', value: 'name', sortable: false },
        { text: 'Cargo', value: 'description', sortable: false },
        { text: 'Correo Electrónico', value: 'mail', sortable: false },
        { text: 'Acciones', value: 'actions', align: 'center', sortable: false }
      ],
      users: [],
      isLoading: true
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.isLoading = true
      adminStorage.getAdminUsers({
        onSuccess: (data) => {
          usersData = data.map((d) => {
            d.mail = d.mail ? d.mail.toUpperCase() : ''
            d.name = d.name ? d.name.toUpperCase() : ''
            d.description = d.description ? d.description.toUpperCase() : ''
            return d
          })
          this.users = JSON.parse(JSON.stringify(usersData))
          this.isLoading = false

          // emits to: /components/header-bar/strategio-app-bar.vue
          eventBus.$emit('enable-tutorial-button')
        },
        onError: (error) => {
          console.warn('Error obteniendo usuarios', error)
          eventBus.$emit('open-custom-snack-bar', {message: 'Ha habido un problema con el servidor', itsOk: false})
        }
      })
    },
    isEnabled (isEnabled) {
      return 'opacity: ' + (isEnabled ? '1' : '0.5')
    },
    openSnackBar (message, itsOk, snackAction) {
      eventBus.$emit('open-custom-snack-bar', {message, itsOk, snackAction})
    },
    search () {
      const q = document.getElementById('txtBuscar').value.trim().toUpperCase()
      const qq = filter(usersData,
        u => u.mail.toUpperCase().indexOf(q) > -1 ||
            u.name.toUpperCase().indexOf(q) > -1 ||
            u.description.toUpperCase().indexOf(q) > -1 ||
            u.userType.toUpperCase().indexOf(q) > -1
      )
      this.users = qq
    },
    getColor (userType) {
      switch (userType) {
        case 'ADMIN': return '#EC39CF'
        case 'SUPERVISOR': return '#9C9C9C'
        case 'GLOBAL': return '#E35361'
        case 'NORMAL': return '#FB9C00'
        case 'DEMO': return '#5E8132'
        default: return 'grey darken-1'
      }
    },
    adminUser (userID) {
      this.$router.push(`/user/admin/${userID}`)
    },
    disableUser (user) {
      adminStorage.updateAccessLevel({
        userID: user.userID,
        newUserType: user.userType,
        isEnabled: !user.isEnabled,
        onSuccess: () => {
          this.openSnackBar('Nivel de acceso actualizado', true)
          this.getData()
        },
        onError: () => this.openSnackBar('Ha habido un error al actualizar el nivel de acceso', false)
      })
    }
  },
  components: {
    UsersListItem
  }
}
</script>

<style>
.strategio-user-admin-sub-division {
  font-size: 24px;
  font-weight: 300;
  margin-top: 24px;
  margin-bottom: 8px;
}

#usersfilter-textfield .v-input__slot {
  background: white;
}
</style>




// WEBPACK FOOTER //
// src/components/users/users-list.vue